import React, { useState, useRef } from "react";
import { Form, Image } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-light-svg-icons";

function SearchComponentHomePage(props) {
  return (
    <div
      className="w-100 d-flex"
      style={{ height: "50px", boxShadow: "0px 0px 1px rgba(0, 0, 0, 0.1)" }}
    >
      <button
        style={{
          border: "1px solid #949494",
          borderRadius: "8px 0px 0px 8px",
          background: "white",
          borderRight: "0",
          paddingLeft: "20px",
          paddingRight: "0px",
        }}
        type="button"
      >
        <Image src="/assets/icons/svg/search.svg" />
      </button>
      <Form.Control
        placeholder={"Search anything here . . . "}
        type="input"
        style={{
          borderRadius: "0px 8px 8px 0px",
          boxShadow: "none",
          borderLeft: "0",
          height: "100%",
        }}
      />
    </div>
  );
}

export default SearchComponentHomePage;
